import SectionHeading from "../ui/SectionHeading";

type Service = {
  title: string;
  description: string;
};

type Stat = {
  value: string;
  label: string;
};

type IntroductionSectionProps = {
  services: Service[];
  stats: Stat[];
};

const IntroductionSection = ({
  services,
  stats,
}: IntroductionSectionProps) => (
  <section className="introduction section-shell" id="about">
    <SectionHeading
      index="01"
      label="About / approach"
      title="Engineering with a feel for the whole experience."
    />

    <div className="introduction__statement">
      <p className="display-statement" data-reveal>
        I turn complex product requirements into software that feels
        <em> clear, useful, and considered.</em>
      </p>
      <div className="introduction__support" data-reveal>
        <p>
          My work spans responsive web platforms, cross-platform mobile
          applications, backend systems, and the interaction details that make
          digital products easier to use.
        </p>
      </div>
    </div>

    <div className="stats-row" aria-label="Career highlights" data-reveal>
      {stats.map((stat) => (
        <div className="stat" key={stat.label}>
          <strong>{stat.value}</strong>
          <span>{stat.label}</span>
        </div>
      ))}
    </div>

    <div className="capabilities">
      <div className="capabilities__sticky" data-reveal>
        <span className="eyebrow">What I do</span>
        <p>From the interface to the systems behind it.</p>
      </div>
      <ol className="capabilities__list">
        {services.map((service, index) => (
          <li key={service.title} data-reveal>
            <span>{String(index + 1).padStart(2, "0")}</span>
            <div>
              <h3>{service.title.replace("IOS", "iOS")}</h3>
              <p>{service.description}</p>
            </div>
            <span className="capabilities__arrow" aria-hidden="true">
              ↘
            </span>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default IntroductionSection;
